/**
 * Created by andrey on 08.08.2025
 */

cc.Animate = function (frames, singleDuration) {
    cc.ActionInterval.prototype.constructor.call(this);

    if (!frames || !singleDuration) {
        throw new Error("cc.Animate: frames must be non-NULL");
    }

    this.initWithFrames(frames, singleDuration);
};

cc.Animate.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: cc.Animate,

    initWithFrames: function (frames, singleDuration) {
        if (this.initWithDuration(singleDuration * frames.length)) {
            this.frames = frames;
            return true;
        }
        return false;
    },

    update: function (dt) {
        dt = this._computeEaseTime(dt);

        const frames = this.frames;
        const index = Math.min(Math.floor(dt * (frames.length)), frames.length - 1);
        this.target.setSpriteFrame(frames[index]);
    }
});

cc.animate = (animation) => new cc.Animate(animation);
